import React, { FunctionComponent, useEffect, useState } from 'react';
import { Icon, Button, Modal, Loader } from '@scuf/common';
import axios from '../../../../utils/APIUtils';
import { ACTION_TRACKING_STATUS, USER_ROLE, TRACKING_COMPLETE, TRACKING_REMINDER, MAIL_SENT, ERROR_MSG_FOR_USER_RESPONSE, OPPORTUNITIES_API_PATHS, TRACKING_SUBMIT } from '../../../../constants/constants';
import { ICommentModal, IMoreContextModal } from '../../../../models/IOpportunitiesAPIModel';
import { getActionTrackingStatus, updateComments, updateMoreContext } from '../../../../services/UserAction';
import { toast, ToastContent, Zoom } from 'react-toastify';
import { Snackbar } from '../../../Snackbar/Snackbar';
import { useAppDispatch } from '../../../../store';
import { Exception } from 'sass';
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from '../../../../constants/constants';
import ReviewCompletionContent from './ReviewCompletetionContent';
import "../../NewCardDesign/CommonStyle.scss"
import './ReviewCompletion.scss';
import {useSelector} from 'react-redux';
import {getCurrentRole} from 'src/slices/onBoardingSlice';
import { getMessage } from 'src/message/utils';

interface IReviewCompletion {
  onClose: Function;
  opportunityId: any;
  role_name?: string;
  trackingStatus?: string;
  closeReview?: Function;
  sendingMailToatser?: Function;
  insightSummaryDisplayCategory?: string;
  modelId?: number;
}

export const ReviewCompletion: FunctionComponent<IReviewCompletion> = (props) => {
  type ToastType = 'loading' | 'failure' | 'success' | 'tracking-complete' | 'tracking-reminder' | 'reject' | 'tracking-submit';
  const [acceptActionInProgress, setacceptActionInProgress] = useState(false);
  const dispatch = useAppDispatch();
  const [hasScript, setHasScript] = useState<boolean>(false);
  const [newNote, setNewNote] = useState('');
  const [hidList, setHidList] = useState([] as any);
  const [loader, setLoader] = useState<boolean>(true);
  const [enableRetryErr, setEnableRetryErr] = useState<boolean>(false);
  const [btnText, setBtnText] = useState<string>('Complete');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [actionTrackingData, setActionTrackingData] = useState([] as any);
  const [retryContent, setRetryContent] = useState<string>('');
  const [isSelfAssignmentTask, SetIsSelfAssignmentTask] = useState<boolean>(false);
  const navigate = useNavigate();
  const currentRole = useSelector(getCurrentRole);
  const reviewTaskHeader = getMessage('app.anomalydetails.rightsection.reviewtask.header');

  const isReadOnly = props.trackingStatus === ACTION_TRACKING_STATUS.ORG_USER_COMPLETE || props.role_name === USER_ROLE.POWER_USER || props.role_name === USER_ROLE.DOMAIN_FOCAL;

  useEffect(() => {
    getActionTracking(props.opportunityId);
  }, []);


  useEffect(() => {
    if (hidList.length === 0) {
      setBtnText('Complete');
    }
  }, [hidList]);

  const getActionTracking = (id: number) => {
    dispatch(getActionTrackingStatus(id,currentRole)).then((response: any) => {
      if (response && response.length > 0) {
        setLoader(false);
        setActionTrackingData(response);
      }
    }).catch((e: Exception) => setLoader(false));
  }


  const trackingSubmitApi = () => {
    const data: ICommentModal = {
      user_comment: 'test',
      type: TRACKING_SUBMIT,
    }; // @ts-ignore  
    dispatch(updateComments(props.opportunityId, data))
      .then(() => {
        setacceptActionInProgress(false);
      })
      .catch((error: any) => {
        setErrorMessage('Error');
        setEnableRetryErr(true);
        setacceptActionInProgress(false);
        setBtnText('Retry');
      });
  }

  // handling the send Reminder scenarion on Checkbox
  const handleReviewCheckBox = (e: any, hid: string) => {
    if (e.target.checked) {
      setBtnText('Send Reminder');
      const newHid = [...hidList];
      newHid.push(hid)
      setHidList(newHid);
    } else {
      let newFilteredHid = [...hidList];
      let updatedHid = newFilteredHid.filter((item) => { return item !== hid });
      setHidList(updatedHid);
    }

  }

  const getCompleteButtonStatus = (data: any) => {
    for (let task of data) {
      for (let action of task.tracking_data) {
        if (btnText === 'Complete' && (action.status === null || action.status === 'red'||action.status === 'white')) {
          return false;
        }
      }
    };
    return true;
  }

  const showActionToast = (toastContent: ToastContent, type: ToastType) => {
    if (type === TRACKING_COMPLETE) {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
    if (type === TRACKING_REMINDER) {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
    if (type === 'reject') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
    if (type === 'tracking-submit') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });

    }
  };

  // Handling Review Complete Button
  const handleReviewComplete = () => {
    setacceptActionInProgress(true);
    let inValidCharacter = /[<>()&#]/;
    if (!inValidCharacter.test(newNote)) {
      if (btnText === 'Complete' || retryContent === 'RetryComplete') {
        const data: ICommentModal = {
          user_comment: " ",
          type: TRACKING_COMPLETE,
        }; // @ts-ignore
        dispatch(updateComments(props.opportunityId, data)).then(() => {
          setacceptActionInProgress(false);
          showActionToast(<Snackbar toastMessage="Task Reviewed successfully." />, 'tracking-complete');
          // props.onClose();
          navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);

        })
          .catch((error: any) => {
            if (error) {
              setErrorMessage(error.response.data.message);
            }
            else { setErrorMessage(ERROR_MSG_FOR_USER_RESPONSE); }
            setEnableRetryErr(true);
            setacceptActionInProgress(false);
            setBtnText('Retry');
            setRetryContent('RetryComplete');
          });

      } else if (btnText === 'Send Reminder' || retryContent === 'RetrySendReminder') {
        let data: IMoreContextModal = {
          shareTo: hidList,
          comment: newNote,
          anomaly_id: `${props.opportunityId}`,
          type: TRACKING_REMINDER
        }; // @ts-ignore
        dispatch(updateMoreContext(props.opportunityId, data)).then((response: any) => {
          // response.data.mail_status === MAIL_SENT ?
          //   props.sendingMailToatser('success', `${response.data.mail_status}`) :
          //   props.sendingMailToatser('failure', `${response.data.mail_status}`);
          showActionToast(
            <Snackbar toastMessage="Reminder send successfully." />,
            'tracking-reminder'
          );
          // props.onClose();
          navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);

        }).catch((error: any) => {
          if (error) {
            setErrorMessage(error.response.data.message);
          }
          else { setErrorMessage(ERROR_MSG_FOR_USER_RESPONSE); }
          setEnableRetryErr(true);
          setacceptActionInProgress(false);
          setBtnText('Retry');
          setRetryContent('RetrySendReminder');
        });
      }
      else {
        setHasScript(true);
        setacceptActionInProgress(false);
      }
    }
  }

  const handlingCompletionSelfAssignment = () => {
    let isSelfAssignment = [] as any;
    actionTrackingData.map((item: any) => {
      isSelfAssignment.push(item.tracking_data.some((actionval: any) => {
        return !isReadOnly && actionval.action_owner_id === actionval.org_owner_id
      }));
    });
    if (isSelfAssignment.some((item: boolean) => { return item === true }) && btnText === 'Complete') {
      const data: ICommentModal = {
        user_comment: '',
        type: TRACKING_SUBMIT,
      }; // @ts-ignore  
      dispatch(updateComments(props.opportunityId, data))
        .then(() => {
          handleReviewComplete();
        })
        .catch((error: any) => {
          setErrorMessage('Error');
          setEnableRetryErr(true);
          setacceptActionInProgress(false);
          setBtnText('Retry');
        });
    } else {
      handleReviewComplete();
    }
  }

  const downloadFileStatusToast = (type: ToastType) => {
    if (type === 'loading') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-info"
            root="common"
            size="large"
            color="#007ad9"
            className="status-indicator-icon"
          />{' '}
          Downloading file. It may take few minutes to complete.{' '}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'success') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-check"
            root="common"
            size="large"
            color="#279d2b"
            className="status-indicator-icon"
          />
          File downloaded successfully.{' '}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'failure') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-stop"
            root="common"
            size="large"
            color="#BE271C"
            className="status-indicator-icon"
          />
          <p>File download operation failed.</p>
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };


  const postActionResponse = (status: string) => {
    //SetIsSelfAssignmentTask(true);
    if (status === 'success') {
      getActionTracking(props.opportunityId);
      showActionToast(
        <Snackbar toastMessage="Task submitted successfully." />,
        'tracking-submit'
      );
    } else {
      showActionToast(
        <Snackbar toastMessage="There is an issue, please try again" />,
        'reject'
      );
      // props.onClose();
    }
  }

  //Download API
  const handleDownload = async (
    insightId: number,
    storedFileName?: string,
    fileName?: string
  ) => {
    downloadFileStatusToast('loading');
    axios
      .get(
        `${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/download?file_name=${fileName}&stored_file_name=${storedFileName}`,
        { responseType: 'blob' }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}`);
        document.body.appendChild(link);
        link.click();
        downloadFileStatusToast('success');
      })
      .catch((err) => {
        downloadFileStatusToast('failure');
        console.log(' error ', err);
      });
  };


  return (
    <>
      <Modal.Header className='review__completion'>{reviewTaskHeader}</Modal.Header>
      {loader && <Loader
        loading={true}
        text="Fetching activity log..."
        minHeight="28vh"
        max-height="70vh"
        overlayColor="transparent"
      />}
      <div className='review__completion--maincontent'>
        {actionTrackingData.map((item: any, key: number) => {
          return (
            <Modal.Content className="review__completion--content">
              <span className="review__completion--reason">{key + 1}. {item.reason}</span>
              {item.tracking_data.map((actionval: any, key: number) => {
                return <div key={actionval.action_tracking_id}>
                  <ReviewCompletionContent isExpanded={true}
                    totalNoOfDays={actionval.no_day_missed}
                    actionOwnerComment={actionval.action_owner_comment}
                    orgOwnerComment={actionval.org_owner_remarks}
                    targetDate={actionval.target_date}
                    actionStatus={actionval.status}
                    actionOwnerHid={actionval.action_owner_id}
                    handleReviewCheckBox={handleReviewCheckBox}
                    insightID={props.opportunityId}
                    uploadedFileDetails={actionval.file_details}
                    actionOwnerId={actionval.action_owner_mail_id}
                    handleFileDownload={handleDownload}
                    userRole={props.role_name}
                    reasonTitle={item.reason}
                    actionType={item.action_type}
                    trainingName={actionval.training_name}
                  />
                </div>
              })}
            </Modal.Content>
          )

        })}
      </div>
      {enableRetryErr && (
        <div className="has_script">{errorMessage}</div>
      )}
      <Modal.Footer className="comments__footer pop-footer">
        <Button
          className="button-space button--secondary notes-cancel"
          size="small"
          type="secondary"
          disabled={acceptActionInProgress}
          onClick={() => {
            props.onClose();
          }}
          content="Cancel"
        />
        {!isReadOnly &&
          <Button
            data-testid="note-add__comment"
            className={`button-space button--primary notes-add--comment ${acceptActionInProgress ? 'notes__footer--readonly btn-loading' : ''
              }`}
            icon={
              enableRetryErr ? (
                <Icon
                  root="building"
                  name="refresh"
                  exactSize={22}
                  className="notes__footer--retry"
                />
              ) : (
                ''
              )
            }
            iconPosition="right"
            size="small"
            type="primary"
            disabled={!getCompleteButtonStatus(actionTrackingData || [])}
            onClick={handlingCompletionSelfAssignment}
            content={btnText}
          />
        }
      </Modal.Footer>
    </>
  );
};